// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"side-bar_sideBar__3OzTm","add-button-wrapper":"side-bar_add-button-wrapper__2qnnD","fit":"side-bar_fit__2qo9o"};